import { setPvMute } from '$logic/pv'
// Common
import { NotificationButton } from '$common/notification-button'
import { usePvByUserId } from '$logic/pv/react-hook'

interface Prop {
  userId: string
}

// FIX: Pass !muted to NotificationButton
export function UserProfileNotification({ userId }: Prop) {
  const { pv } = usePvByUserId(userId)

  if (!pv) return null
  const { roomId, muted } = pv

  return (
    <NotificationButton
      muted={muted}
      onClick={() => setPvMute(roomId, !muted)}
    />
  )
}
